/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PutVehicleAccessGrantRequestDto,
  VehicleAccessDto,
  VehicleAccessGrantDto,
  VehicleAccessGrantRemovalDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * The vehicle's Owner (read-only) and its Vehicle access grants, oldest first, each with its level, the BattAdmin who gave it and whether the user has an active membership (not blocked, with a driver grade valid now). Not cached: a change is visible on the next call. BattAdmin only.
 * @summary getVehicleAccess
 */
export const getVehicleAccess = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleAccessDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/users`, method: 'GET', signal
    },
      );
    }
  

export const getGetVehicleAccessQueryKey = (vehicleId?: string,) => {
    return [`/fleet/vehicle/v1/vehicles/${vehicleId}/users`] as const;
    }

    
export const getGetVehicleAccessQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleAccess>>, TError = ErrorType<null | null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAccess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleAccessQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleAccess>>> = ({ signal }) => getVehicleAccess(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleAccess>>>
export type GetVehicleAccessQueryError = ErrorType<null | null | null | null>


export function useGetVehicleAccess<TData = Awaited<ReturnType<typeof getVehicleAccess>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleAccess>>,
          TError,
          Awaited<ReturnType<typeof getVehicleAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleAccess<TData = Awaited<ReturnType<typeof getVehicleAccess>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleAccess>>,
          TError,
          Awaited<ReturnType<typeof getVehicleAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleAccess<TData = Awaited<ReturnType<typeof getVehicleAccess>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getVehicleAccess
 */

export function useGetVehicleAccess<TData = Awaited<ReturnType<typeof getVehicleAccess>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAccess>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleAccessQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gives the user the level on the vehicle, or changes the level of the grant they hold. Idempotent: repeating the same level changes nothing, not even who granted it. The new level applies from the user's next request. BattAdmin only.
 * @summary putVehicleAccessGrant
 */
export const putVehicleAccessGrant = (
    vehicleId: string,
    userRemoteId: string,
    putVehicleAccessGrantRequestDto: BodyType<PutVehicleAccessGrantRequestDto>,
 ) => {
      
      
      return customInstance<VehicleAccessGrantDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/users/${userRemoteId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putVehicleAccessGrantRequestDto
    },
      );
    }
  


export const getPutVehicleAccessGrantMutationOptions = <TError = ErrorType<null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVehicleAccessGrant>>, TError,{vehicleId: string;userRemoteId: string;data: BodyType<PutVehicleAccessGrantRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putVehicleAccessGrant>>, TError,{vehicleId: string;userRemoteId: string;data: BodyType<PutVehicleAccessGrantRequestDto>}, TContext> => {

const mutationKey = ['putVehicleAccessGrant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVehicleAccessGrant>>, {vehicleId: string;userRemoteId: string;data: BodyType<PutVehicleAccessGrantRequestDto>}> = (props) => {
          const {vehicleId,userRemoteId,data} = props ?? {};

          return  putVehicleAccessGrant(vehicleId,userRemoteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVehicleAccessGrantMutationResult = NonNullable<Awaited<ReturnType<typeof putVehicleAccessGrant>>>
    export type PutVehicleAccessGrantMutationBody = BodyType<PutVehicleAccessGrantRequestDto>
    export type PutVehicleAccessGrantMutationError = ErrorType<null | null | null | null | null | null>

    /**
 * @summary putVehicleAccessGrant
 */
export const usePutVehicleAccessGrant = <TError = ErrorType<null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVehicleAccessGrant>>, TError,{vehicleId: string;userRemoteId: string;data: BodyType<PutVehicleAccessGrantRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVehicleAccessGrant>>,
        TError,
        {vehicleId: string;userRemoteId: string;data: BodyType<PutVehicleAccessGrantRequestDto>},
        TContext
      > => {

      const mutationOptions = getPutVehicleAccessGrantMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Removes the user's grant on the vehicle. Idempotent: a user who held none yields removed=false rather than a 404, so the caller can tell the two apart. The Owner's rights are not a grant and cannot be removed here. BattAdmin only.
 * @summary deleteVehicleAccessGrant
 */
export const deleteVehicleAccessGrant = (
    vehicleId: string,
    userRemoteId: string,
 ) => {
      
      
      return customInstance<VehicleAccessGrantRemovalDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/users/${userRemoteId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteVehicleAccessGrantMutationOptions = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVehicleAccessGrant>>, TError,{vehicleId: string;userRemoteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteVehicleAccessGrant>>, TError,{vehicleId: string;userRemoteId: string}, TContext> => {

const mutationKey = ['deleteVehicleAccessGrant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVehicleAccessGrant>>, {vehicleId: string;userRemoteId: string}> = (props) => {
          const {vehicleId,userRemoteId} = props ?? {};

          return  deleteVehicleAccessGrant(vehicleId,userRemoteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVehicleAccessGrantMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVehicleAccessGrant>>>
    
    export type DeleteVehicleAccessGrantMutationError = ErrorType<null | null | null>

    /**
 * @summary deleteVehicleAccessGrant
 */
export const useDeleteVehicleAccessGrant = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVehicleAccessGrant>>, TError,{vehicleId: string;userRemoteId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVehicleAccessGrant>>,
        TError,
        {vehicleId: string;userRemoteId: string},
        TContext
      > => {

      const mutationOptions = getDeleteVehicleAccessGrantMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    